import { useSelector } from 'react-redux';
import { Stack } from '@rossum/ui/material';
import { customApiUrl } from '../../constants/config';
import { OverduePaymentsBanner } from '../../features/overdue-payments/OverduePaymentsBanner';
import { overduePaymentsSelector } from '../../features/overdue-payments/selectors/overduePaymentsSelector';
import { dataCaptureLockSelector } from '../../features/pricing/selectors';
import { showNetworkAlertSelector } from '../../redux/modules/ui/selectors';
import ChangeApiAlert from './components/ChangeApiAlert';
import { DataCaptureLockedBanner } from './components/DataCaptureLockedBanner';
import NetworkAlert from './components/NetworkAlert';

const Announcements = () => {
  const showNetworkAlert = useSelector(showNetworkAlertSelector);
  const { isOverdue, messageKey, severity } = useSelector(
    overduePaymentsSelector
  );
  const dataCaptureLocked = useSelector(dataCaptureLockSelector);

  return (
    <Stack sx={{ zIndex: 100, position: 'relative' }}>
      {isOverdue && (
        <OverduePaymentsBanner messageKey={messageKey} severity={severity} />
      )}
      {dataCaptureLocked && <DataCaptureLockedBanner />}
      {!!customApiUrl && <ChangeApiAlert changedApiUrl={customApiUrl} />}
      {showNetworkAlert && <NetworkAlert />}
    </Stack>
  );
};

export default Announcements;
